import {
  faCalendar,
  faGift,
  faHome,
  faMusic,
  faPhotoVideo,
  faUserGroup,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default function BottomBar({ visible, onMusic }) {
  return (
    // PERBAIKAN ANIMASI HIDE:
    // Menggunakan translate-y-[150%] dan invisible agar saat di Cover benar-benar hilang dari layar dan tidak bisa dipencet tak sengaja.
    <div
      className={`fixed z-[99] pointer-events-none transition-all duration-700 ease-in-out px-4 md:px-0
        bottom-4 left-0 right-0 md:left-auto md:right-8 flex justify-center
        ${visible ? "translate-y-0 opacity-100 visible" : "translate-y-[150%] opacity-0 invisible"}
      `}
    >
      {/* PERBAIKAN RESPONSIVITAS WEB: 
          1. Di mobile pakai w-full max-w-[360px] dengan justify-between (menyebar rata).
          2. Di web (md) pakai max-w-max dengan justify-center dan gap-8 agar ikon punya jarak lega dan tidak mepet. 
      */}
      <div className="pointer-events-auto w-full max-w-[360px] md:max-w-max flex justify-between md:justify-center md:gap-8 items-center bg-black/85 backdrop-blur-md rounded-2xl px-5 md:px-8 py-3 shadow-2xl border border-white/10">
        <a
          href="#home"
          className="flex flex-col items-center gap-1.5 transition-transform duration-200 hover:scale-110 group"
        >
          <FontAwesomeIcon
            icon={faHome}
            className="text-gray-400 group-hover:text-white text-sm md:text-base transition-colors"
          />
          <span className="text-[10px] text-gray-400 group-hover:text-white font-medium">
            Home
          </span>
        </a>

        {/* PERBAIKAN LINK MEMPELAI: href diubah ke #couple */}
        <a
          href="#couple"
          className="flex flex-col items-center gap-1.5 transition-transform duration-200 hover:scale-110 group"
        >
          <FontAwesomeIcon
            icon={faUserGroup}
            className="text-gray-400 group-hover:text-white text-sm md:text-base transition-colors"
          />
          <span className="text-[10px] text-gray-400 group-hover:text-white font-medium">
            Mempelai
          </span>
        </a>

        <a
          href="#acara"
          className="flex flex-col items-center gap-1.5 transition-transform duration-200 hover:scale-110 group"
        >
          <FontAwesomeIcon
            icon={faCalendar}
            className="text-gray-400 group-hover:text-white text-sm md:text-base transition-colors"
          />
          <span className="text-[10px] text-gray-400 group-hover:text-white font-medium">
            Acara
          </span>
        </a>

        <a
          href="#gallery"
          className="flex flex-col items-center gap-1.5 transition-transform duration-200 hover:scale-110 group"
        >
          <FontAwesomeIcon
            icon={faPhotoVideo}
            className="text-gray-400 group-hover:text-white text-sm md:text-base transition-colors"
          />
          <span className="text-[10px] text-gray-400 group-hover:text-white font-medium">
            Gallery
          </span>
        </a>

        <a
          href="#gift"
          className="flex flex-col items-center gap-1.5 transition-transform duration-200 hover:scale-110 group"
        >
          <FontAwesomeIcon
            icon={faGift}
            className="text-gray-400 group-hover:text-white text-sm md:text-base transition-colors"
          />
          <span className="text-[10px] text-gray-400 group-hover:text-white font-medium">
            Gift
          </span>
        </a>

        <button
          onClick={onMusic}
          className="flex flex-col items-center gap-1.5 transition-transform duration-200 hover:scale-110 group cursor-pointer bg-transparent border-none p-0 outline-none"
        >
          <FontAwesomeIcon
            icon={faMusic}
            className="text-gray-400 group-hover:text-white text-sm md:text-base transition-colors"
          />
          <span className="text-[10px] text-gray-400 group-hover:text-white font-medium">
            Musik
          </span>
        </button>
      </div>
    </div>
  );
}
